import { render, staticRenderFns } from "./OTParcelList.vue?vue&type=template&id=56271c4e&scoped=true&"
import script from "./OTParcelList.vue?vue&type=script&lang=js&"
export * from "./OTParcelList.vue?vue&type=script&lang=js&"
import style0 from "./OTParcelList.vue?vue&type=style&index=0&id=56271c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56271c4e",
  null
  
)

export default component.exports